import axios from 'axios'

/**
 * True when an axios error represents a client-side cancellation
 * (AbortController.abort or axios.CancelToken). Not a real network failure.
 */
export const isCancelled = (error) => axios.isCancel(error) || error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError'

/**
 * True when an axios error represents a genuine network failure
 * (no response received and not a client-side cancellation/timeout).
 */
export const isNetworkError = (error) => !error?.response && error?.code !== 'ECONNABORTED' && !isCancelled(error)
